export default __webpack_public_path__ + "static/media/Inter-ExtraLightItalic.04abe79a.woff2";